import { IS_SERVER } from "@/constants";
import { InteractionValueEnum, InteractionEnum } from "@/types";
// Needed for customerActions
export const buildSendMailActionParams = (props) => {
    const defaultParams = [
        {
            key: InteractionEnum.CLICK,
            value: InteractionValueEnum.FINANCING,
        },
        { key: "type", value: "email" },
        {
            key: "email",
            value: props.email,
        },
        {
            key: "isDefaultAnnotation",
            value: true,
        },
        {
            key: "isOwner",
            value: !!props.isOwner,
        },
    ];
    if (IS_SERVER)
        return defaultParams;
    return [
        ...defaultParams,
        { key: "host", value: window.location.host },
        { key: "urlReferrer", value: document.referrer },
        {
            key: "placement",
            value: new URL(window.location.href).searchParams.get("placement"),
        },
    ];
};
